import { render, staticRenderFns } from "./CompanyDrawerSummaryTab.vue?vue&type=template&id=0d4ff861&scoped=true&"
import script from "./CompanyDrawerSummaryTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerSummaryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ff861",
  null
  
)

export default component.exports